import { ReactElement} from "react";
import { useTranslation } from "react-i18next";
import NavbarComponent from "./navbar-component";
interface IProps {
  children: ReactElement;
  showLogo?: boolean;
  logoStyle?: string;
}
function LayoutComponent({ children, showLogo, logoStyle }: IProps) {
  const { t } = useTranslation();
  return (
    <>
      {/* Navbar Component */}
      <NavbarComponent showLogo={showLogo} logoStyle={logoStyle} />
      <div
        className={`${
          window.location.href.includes("details")
            ? " bg-mint-500 h-[190px] mobile:h-[182px] mobile:w-full"
            : ""
        }`}
      ></div>
      {children}
      <div className="flex flex-col items-end justify-center h-[181px] mobile:h-[73px] pl-8 gap-8 mobile:gap-2 drop-shadow-[0_0px_10px_rgba(0,0,0,0.05)]">
        <img alt="" src="/assets/images/logo.svg" className="h-16 mobile:h-6" />
        <p className="font-arMedium text-sm text-blue-600 mobile:font-ar mobile:text-[8px]">
          {t("layout.component.allrightsreserved")}
        </p>
      </div>
    </>
  );
}

export default LayoutComponent;
